/**
 * Bump for any narrowing of a published contract, including value-level ones.
 */
export const SCHEMA_EPOCH = 3;
//# sourceMappingURL=epoch.js.map